export default __webpack_public_path__ + "images/0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7.png";